import { apiClient } from './client';

export interface TransferLimits {
  dailyLimit: string;
  usedToday: string;
  remaining: string;
  feePercent: number;
}
export interface TransferResult {
  sent: string;
  fee: string;
  received: string;
  to: string;
  newBalance: string;
}

export const transferApi = {
  limits: () => apiClient.get<TransferLimits>('/transfer/limits').then((r) => r.data),
  send: (to: string, amount: string) =>
    apiClient.post<TransferResult>('/transfer', { to, amount }).then((r) => r.data),
};
